<template>
  <PopupTips :list="bonusList" :z-index="101">
    <div class="bonusTips" :class="{ 'justify-center': bonusList.length < 3 }">
      <div class="item" v-for="(item, i) in bonusList" :key="i">
        <p class="title">{{ item.type }}</p>
        <img class="wh-[40px_27px] mt-1" src="@a/assets/images/i_money.png" />
        <p class="amount">
          {{ formatter().format(item.amount) }}
          <span class="text-11 font-normal">R$</span>
        </p>
        <div @click="getBonus({ id: item.id, type: item.type })" class="btn">RECEBER</div>
      </div>
    </div>
  </PopupTips>
</template>

<script setup lang="ts">
import PopupTips from "@a/components/popupTips/index.vue";
import i18n from "@/i18n";
import { getBonusList, receiveBonus } from "@/api/activity";
import { formatter } from "@/utils";

const t = i18n.global.t;

const bonusList = ref<any[]>([]);

const titles = {
  DepositBonus: "DAR DINHEIRO",
  InviteeReward: "SER CONVIDADO",
};

// 查询是否存在奖励
const getBonusListData = async () => {
  const { code, data } = await getBonusList();
  if (code === 1 && data) {
    bonusList.value = data
      .filter((item) => Number(item.amount) > 0)
      .map((item) => {
        return {
          ...item,
          title: titles[item.flowType] || "unknown",
        };
      });
  }
};

onActivated(() => {
  getBonusListData();
})

// 彩金领取
const getBonus = async (params) => {
  showLoadingToast('loading...');
  const { code } = await receiveBonus(params).catch(() => ({code: 0, data: null}));
  if (code === 1) {
    showToast({
      icon: "success",
      message: t("Common.Success"),
    });
    getBonusListData();
  } else {
    showToast({
      icon: "fail",
      message: t("Common.Fail"),
    });
  }
};
</script>

<style lang="scss" scoped>
.bonusTips {
  background: url(@a/assets/images/bg_bonus_bonus.png) no-repeat center top / 274px 237px;
  width: 327px;
  padding-top: 250px;
  display: flex;
  text-align: center;
  gap: 12px;
  overflow-x: auto;

  .item {
    min-width: 100px;
    height: 153px;
    background: url(@a/assets/images/bg_bonus_1.png) 0 0 / cover;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      height: 36px;
      line-height: 16px;
      color: var(--theme-text-dark);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      padding-top: 2px;
    }

    .amount {
      font-size: 15px;
      font-weight: 600;
      color: #5dc025;
      margin-top: 12px;
    }

    .btn {
      width: 76px;
      height: 26px;
      text-align: center;
      line-height: 26px;
      color: #933df7;
      color: #fff;
      border-radius: 13px;
      background-color: #61c325;
      margin-top: 22px;
    }
  }
}
</style>
